/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Heading, Text, ContentContainerBodyShift, SkipLink } from 'sarsaparilla';
import SitePassFacilities from './SitePassFacilities';

import './SitePass.scss';

function SitePass() {
    return (
        <section aria-label="Site Pass" id="site-specific-digital-passes">
            <ContentContainerBodyShift>
                <div className="content-body">
                    <SkipLink position="above" href="#skip-to-which-pass">
                        Skip to Which Pass Do I Need
                    </SkipLink>

                    <Heading
                        headingLevel={2}
                        hasUnderline="left"
                        appearance="h4"
                        id="site-pass-recommended-for"
                    >
                        Site Passes
                    </Heading>
                    <div className="recommended-for">
                        <Text size="lg" fontWeight="semibold">
                            Recommended for:
                        </Text>
                        <ul aria-labelledby="site-pass-recommended-for">
                            <li>Visiting a specific federal recreation location</li>
                            <li>Single visit or yearly passes available</li>
                        </ul>
                    </div>
                    <p>
                        These digital passes cover entrance or standard amenity (day-use)
                        fees at a single location. Destinations across the country offer
                        the convenience of digital passes, with a variety of pass options
                        at each individual location for daily, weekly, seasonal, and/or
                        annual visitation. Site Passes are also available immediately for
                        download and can be used from your phone or tablet.
                    </p>
                    {/* Site Pass Search and Map */}
                    <SitePassFacilities />
                </div>
            </ContentContainerBodyShift>
        </section>
    );
}

export default SitePass;
